import * as React from 'react';
import { createPortal } from 'react-dom';

import ActionButtonDropdownMenu from '../menu/ActionButtonDropdownMenu';

import './action-button-dropdown-menu-container.scss';

import type { ActionButtonDropdownElementRef, ActionButtonDropdownItem, ActionButtonDropdownStyle } from 'types';

type Props = {
  controlRef: ActionButtonDropdownElementRef<HTMLElement>,
  items: Array<ActionButtonDropdownItem>,
  isMenuOpen: boolean,
  style?: ActionButtonDropdownStyle,
  withSelectable?: boolean,
  withCenteredMenu?: boolean,
  withRightAlignedMenu?: boolean,
  withCustomWidthMenu?: boolean,
  hasCustomButton: boolean,
  CustomMenu?: React.ReactNode,
  menuClassName?: string,
  menuItemClassName?: string,
  onItemClick: (a: string) => void
};

class ActionButtonDropdownMenuContainer extends React.PureComponent<Props> {
  menuContainer: HTMLElement = document.createElement('div');

  componentDidMount() {
    if (document.body && !document.body.contains(this.menuContainer)) {
      document.body.appendChild(this.menuContainer);
    }
  }

  componentWillUnmount() {
    if (document.body && document.body.contains(this.menuContainer)) {
      document.body.removeChild(this.menuContainer);
    }
  }

  handleItemClick = (identifier: string): void => {
    const { onItemClick } = this.props;

    onItemClick(identifier);
  };

  renderMenu(): React.ReactNode {
    const {
      items,
      style,
      controlRef,
      hasCustomButton,
      menuClassName,
      menuItemClassName,
      withSelectable,
      withCenteredMenu,
      withRightAlignedMenu,
      withCustomWidthMenu,
      CustomMenu
    } = this.props;

    return createPortal(
      <ActionButtonDropdownMenu
        items={items}
        style={style}
        controlRef={controlRef}
        withSelectable={withSelectable}
        withCenteredMenu={withCenteredMenu}
        withRightAlignedMenu={withRightAlignedMenu}
        withCustomWidthMenu={withCustomWidthMenu}
        hasCustomButton={hasCustomButton}
        CustomMenu={CustomMenu}
        menuClassName={menuClassName}
        menuItemClassName={menuItemClassName}
        onItemClick={this.handleItemClick}
      />,
      this.menuContainer
    );
  }

  render(): React.ReactNode {
    const { isMenuOpen } = this.props;

    return (
      <div className="action-button-dropdown-menu-container">
        {
          isMenuOpen &&
            this.renderMenu()
        }
      </div>
    );
  }
}

export default ActionButtonDropdownMenuContainer;
